export const urls = {
  list: () => `/v1/offer-letters/`,
}
